module.exports = __webpack_public_path__ + "img/2.e3bbb0c3.webp";